import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";

import {DataService} from "../../../providers/data-service";
import {ShowviewAtracaoPage} from "../showview-atracao/showview-atracao";
import {HotspotService} from "../../../providers/hotspot-service";
import {DomSanitizer} from "@angular/platform-browser";
import {TAction, TGaleriaTipo} from "../../../app/enum";
import {HttpService} from "../../../providers/http-service";

/*
@IonicPage({
    //name: 'page-showview', usado para o .push
    //segment: 'showview', // #/showview
    //defaultHistory: [ProfilePagePage]
    //priority: 'high'
})
*/

@Component({
    selector: 'page-showview',
    templateUrl: 'showview.html',
    providers: [HotspotService]
})

export class ShowviewPage {

    config: any;
    logado: any;
    perfil: any;

    etapa: number;
    selected: number;

    screens: Array<any> = [];
    alertas: Array<any> = [];


    tipo: string = '';


    hotspotID: number;
    usuarioID: number;
    monitorIP: string;
    alertaID: number;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public viewCtrl: ViewController, public sanitizer: DomSanitizer,
                public http: HttpService,
                public dataService: DataService,
                public logadoService: LogadoService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;

        //APP-NEW-VERSION - REVISAR

        this.screens = this.navParams.get('screens');
        this.tipo = (this.screens ? 'novidade' : 'atracao');

        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'), this.dataService.get('param.hotspotid'));
        this.usuarioID = this.util.anyParams(0, this.navParams.get('param.usuarioID'), this.dataService.get('param.usuarioid'));
        //this.util.anyParams(0, this.navParams.get('usuarioIS'), this.dataService.get('param.usuariois')),
        this.monitorIP = this.util.anyParams('', this.navParams.get('monitorIP'), this.dataService.get('param.monitorip'));
        this.alertaID = this.util.anyParams(0, this.navParams.get('alertaid'), this.dataService.get('param.alertaid'));


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showview - Novidade', '/showview');

        if (!this.screens) this.load(this.hotspotID);

    }

    load(hotspotID) {

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&MonitorIP=' + this.monitorIP + '&UsuarioID=' + this.usuarioID + '&AlertaID=' + this.alertaID;

        this.hotspotService.galeria(TAction.acLoad, hotspotID, 0, TGaleriaTipo.gtNenhum, null, params)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                this.selected = 0;
                this.screens = data.Galerias.Screens;
                this.alertas = data.Galerias.Alertas;

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    alerta() {

        /*
        let uriParams: string = '';
        let params = this.dataService.get();

        for (let key in params) {
            if (key.indexOf('param.') === -1) {
                continue;
            }
            uriParams = uriParams + '&' + key.replace('param.', '') + '=' + params[key] + '&alertid=' + this.intAlerta;
        }
        */

        this.http.get(this.alertas[0].GaleriaLink, {}, false)
            .subscribe( //Exclui o informe aceito
                data => this.alertas.splice(0, 1),
                erro => this.util.alertResult(erro)
            );

            this.alertas.splice(0, 1);
            
    }

    openListaNovidade() {

        let objectData = {etapa: 1, screens: this.screens};
        let objectOpts = {enableBackdropDismiss: false, cssClass: "page-novidade-modal-lista"};

        this.util.modalopen(ShowviewPage, 'wide', false, objectData, null, objectOpts).subscribe(
            data => {
                if (data) this.selected = data.index;
            });

    }

    openAtracao() {

        this.navCtrl.setRoot(ShowviewAtracaoPage, {}, {animate: true, direction: 'forward'});

    }

    dismiss() {

        this.navCtrl.pop();

    }

    closeModal() {

        this.viewCtrl.dismiss();

    }

    selectIndex(index) {

        this.viewCtrl.dismiss({index: index});

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showview/showview.ts